<template>
  <v-card class="d-inline-block rounded-xl custom-background my-1">
    <v-card-text class="pa-0" >
      <v-breadcrumbs
        class="pa-4"
        :items="items"
        large
      />
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'Breadcrumbs',
    props: {
      items: {
        Array,
        isRequired: true,
      },
    },
  }
</script>
<style>
.v-breadcrumbs__item:not(.v-breadcrumbs__item--disabled){
  font-family: IranSansBold !important;
}
</style>
<style scoped>
.custom-background{
  background: rgba(255,255,255,0.5);
}

</style>
